import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './config'

Vue.use(Router)

const router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  if (document.documentElement.scrollTop !== 0) document.documentElement.scrollTop = 0
  if (document.body.scrollTop !== 0) document.body.scrollTop = 0
  if (to.name !== 'news') {
    next()
  }
})

export default router
